module.exports = __webpack_public_path__ + "static/media/404.d86330d5.png";